import { useCallback, useEffect, useMemo, useState } from 'react'
import { useMatch } from '@reach/router'
import { t } from 'i18next'
import { Helmet } from 'react-helmet'
import { useQuery } from 'react-query'
import { SortBy } from 'src/components/shared/EnhancedTable/AsyncEnhancedTable'
import EscritosView from 'src/components/views/Escritos/EscritosView'
import { ESCRITOS } from 'src/constants/routes'
import { useLexnetStatusContext } from 'src/contexts/LexnetStatusContext'
import { TipoEscrito } from 'src/enums/EscritosLegales'
import { getEscritos } from 'src/services/EscritosServices'

type State = {
  pageIndex: number
  pageSize: number
  sortBy: SortBy[]
  searchedText: string
}

export default function Escritos(): JSX.Element {
  const { connected } = useLexnetStatusContext()
  const isDraft = useMatch(ESCRITOS('borradores')) !== null

  const [paginationOptions, setPaginationOptions] = useState<State>({
    pageIndex: 0,
    pageSize: 10,
    sortBy: [],
    searchedText: ''
  })
  const tipo = useMemo(() => {
    if (isDraft) {
      return [TipoEscrito.BORRADOR]
    }
    return [TipoEscrito.ESCRITO]
  }, [isDraft])

  const tipoEscrito = useMemo(() => {
    return []
  }, [])

  const estado = useMemo(() => {
    return []
  }, [])

  const queryKey = [
    'escritosListed',
    estado,
    tipo,
    tipoEscrito,
    paginationOptions.pageIndex,
    paginationOptions.pageSize,
    paginationOptions.searchedText
  ]
  if (paginationOptions.sortBy.length > 0) {
    queryKey.push(paginationOptions.sortBy[0].id)
    queryKey.push(paginationOptions.sortBy[0].desc ? 'desc' : 'asc')
  }

  const messagesQuery = useQuery(queryKey, () =>
    getEscritos(
      { estado, tipo, tipoEscrito },
      paginationOptions.pageIndex + 1,
      paginationOptions.pageSize,
      paginationOptions.sortBy,
      paginationOptions.searchedText
    )
  )

  const { refetch } = messagesQuery
  useEffect(() => {
    if (connected) {
      refetch()
    }
  }, [connected, refetch])

  const onChangePaginationOptions = useCallback(function(value) {
    setPaginationOptions(value)
  }, [])

  let subsection = t('breadcrumbs.all_legal_writting')

  if (isDraft) {
    subsection = t('breadcrumbs.drafts')
  }

  return (
    <>
      <Helmet>
        <title>Mensajes</title>
      </Helmet>
      <EscritosView
        messagesQuery={messagesQuery}
        onChangePaginationOptions={onChangePaginationOptions}
        subsection={subsection}
        pageSize={paginationOptions.pageSize}
      />
    </>
  )
}
